import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';

//import moment from 'moment';

export const sessionMixins = {

    data: () => ({

    }),
    mounted: function () {
        var self = this;
    },
    created() {

    },
    beforeMount() {

    },

    computed: {
    },

    watch: {
    },

    methods: {
        getUserFromToken(token, redirect) {
            // console.log(redirect);
            var self = this;

            var config = {
                headers: {Authorization: "Bearer " + token},
                /*params: {
                 'type': self.categoryType,
                 }*/
            };
            HTTP.get(process.env.GETUSER_BYTOKENAPI, config)
                    .then(function (response) {
                        // if (response.data.status == "success") {
                            //self.timezones = response.data.content;
                          //  localStorage.setItem("expiry", moment(new Date()).add(6, 'h').toDate());
                            localStorage.setItem("api_token", token);
                            localStorage.setItem("user_obj", JSON.stringify(response.data));
                            // window.localStorage.setItem("profile_image", response.data.content.user_obj.profile_image);

                            self.setCookie('vvg_sso_auth_token', token, 365);
                            var username="";
                            if(response.data.hasOwnProperty('name')){
                                username = response.data['name'];
                            } else if(response.data.hasOwnProperty('username')) {
                                username = response.data['username'];
                            } else if(response.data.hasOwnProperty('first_name')) {
                                username = response.data['first_name'];
                            } else if($response.data.hasOwnProperty('last_name')) {
                                username = response.data['last_name'];
                            }
                            EventBus.$emit('login-user-info',
                                    true,
                                    username,
                                    response.data["first_name"],
                                    response.data["last_name"],
                                    );
                            if (redirect) {
                                //window.location.href=redirect;
                                self.$router.push(redirect);
                            } else {
                                self.$router.push("/");
                            }
                        // } else {
                        //     $("#errorMsg").html(response.data.message);
                        //     if (response.data.length > 0) {
                        //         var err = "";
                        //         err += response.data.content + "<br>";
                        //         $("#errorMsg").html(err);
                        //     }
                        // }
                    })
                    .catch(function (err) {
                        // console.log(err);
                        self.setCookie('vvg_sso_auth_token', '', 365);
                        self.Registerbtn = "Register";
                        // if (err.response.status == 0) {
                        //     self.error = "Remote server can not be reachable";
                        // } else {
                        //     $("#errorMsg").html(err.response.data.message);
                        //     if (err.response.data.content.length > 0) {
                        //         var err = "";
                        //         err += err.response.data.content + "<br>";
                        //         $("#errorMsg").html(err);
                        //     }
                        // }
                       // openDirectLink('/');
                    });

        },
        setCookie: function (cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/sessionMixins.js